import { twMerge } from "tailwind-merge";

/**
 * Utility function to conditionally join classNames together.
 * Wraps the tailwind-merge package for consistent usage across the app.
 * 
 * @param  {...any} args - Class names, objects, or arrays to combine
 * @returns {string} - Combined class names string
 * 
 */
export const cn = (...args) => {
  return twMerge(...args);
};

export default cn;

